import { useDispatch } from '@lingoda/hooks';
import { DialogComponent, showDialog } from '@lingoda/dialogs';
import { Button } from '@lingoda/ui';
import { KeyboardArrowDownIcon } from '@lingoda/ui/icons';
import { GlobeIcon16 } from '@lingoda/ui/icons/GlobeIcon';
import { useCurrentLocale } from '../hooks';

export const AppLanguageSelect = () => {
    const dispatch = useDispatch();
    const currentLocale = useCurrentLocale();

    const handleLanguageClick = () => {
        dispatch(showDialog(DialogComponent.AppLanguageDialog));
    };

    return (
        <Button
            variant="text"
            size="small"
            onClick={handleLanguageClick}
            startIcon={<GlobeIcon16 />}
            endIcon={<KeyboardArrowDownIcon />}
        >
            {currentLocale.label}
        </Button>
    );
};
